import { humanizeBn } from 'tools/math';
import { IDexPair } from 'types/pairs';

import { convertTokenDEX } from './convertToken';

type Params = {
  pair: IDexPair;
  totalAmount: string;
  totalCurrency: string;
  minAmount: string;
  maxAmount: string;
  tradesCurrency: string;
};

export const normalizeBuySellEstimateAmounts = ({
  pair,
  totalAmount,
  totalCurrency,
  minAmount,
  maxAmount,
  tradesCurrency,
}: Params) => {
  const toBase = (amount: string, from: string) =>
    humanizeBn(
      convertTokenDEX({
        from,
        to: pair.token_base.symbol,
        pair,
        amount,
        decimals: pair.token_base.decimals,
      }),
      pair.token_base.decimals,
    );

  return {
    totalAmount: toBase(totalAmount, totalCurrency),
    minAmount: toBase(minAmount, tradesCurrency),
    maxAmount: toBase(maxAmount, tradesCurrency),
  };
};
